module.exports = __webpack_public_path__ + "media/hph-24-12_commencement.0b4c69a0.mp4";